import styled from 'styled-components';

export const NewManagementContainerStyled = styled.div`
  min-width: 1024px;
  overflow: auto;
  padding-left: 5px;
  margin-left: -5px;
  margin-right: -20px;
  .show_loading {
    height: calc(100vh - 85px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .manage_container {
    margin-right: 20px;
    padding: 15px 32px 80px 32px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 18px;
    border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_3};
    .head_wrap_layout {
      margin-bottom: 22px;
    }
    .bottom_control {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.BLUE_1};
      margin-bottom: 31px;
      .tab_show {
        display: flex;
        .tab_select {
          padding: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size:  ${({ theme }) => theme.FONT.SIZE.S22};
          font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
          border-bottom: 4px solid ${({ theme }) => theme.COLORS.PURPLE_1};
        }
      }
      .group_button_layout {
        display: flex;
        align-items: flex-end;
        padding-bottom: 16px;
        .del_button {
          width: 144px;
          margin-right: 16px;
        }
      }
    }
    
    .block_2_col_layout {
      display: flex;
      padding: 10px 0;
      column-gap: 16px;
      .col_2 {
        &.flex_1 {
          flex: 1;
        }
        &.w_280 {
          flex-shrink: 0;
          width: 280px;
        }
      }
    }
  }
`;
